import actionTypes from "./actionTypes";

const userAction = {
  authenticate: () => ({
    type: actionTypes.AUTHENTICATE,
  }),
  authenticateSuccess: (user) => ({
    type: actionTypes.AUTHENTICATE_SUCCESS,
    payload: user,
  }),
  updateAccessToken: (accessToken) => ({
    type: actionTypes.UPDATE_ACCESS_TOKEN,
    payload: accessToken,
  }),
  logout: () => ({
    type: actionTypes.LOGOUT,
  }),
};

export default userAction;
